import { UploadedFileType } from '@/components/shared/file-uploader/model/types'

import { FileCardType } from './FileCard.types'

export const cardMapper: (data: UploadedFileType) => FileCardType = data => {
  const fileBytes = data.file?.size || 0

  const units = ['Б', 'кБ', 'мБ']
  const exponent = Math.min(
    Math.floor(Math.log(fileBytes) / Math.log(1024)),
    units.length - 1
  )
  const approx = fileBytes / 1024 ** exponent

  const output =
    exponent === 0
      ? `${fileBytes} Б`
      : `${Math.round(approx)} ${units[exponent]}`

  return {
    id: data.id,
    image: data.url || undefined,
    file: data.file,
    loading: data.loading,
    fileName: data.file?.name,
    fileSizeWithUnit: fileBytes ? output : undefined,
    fileSize: fileBytes,
    fileBytes,
    fileType: data.file?.type?.toUpperCase()?.split('/')[1],
    progress: data.progress,
    error: data.error
  }
}
